import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Button from "../reusable/button"
import { document, window } from "browser-monads"
import Currency from "@src/components/indy-tour-page/core-value-local-currency-v2"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.5rem;
  font-family: Arial, sans-serif;
  @media (max-width: 850px) {
    margin-top: 24px;
  }
`

const Tabs = styled.div`
  display: flex;
  width: 100%;
`

const Tab = styled.span`
  cursor: pointer;
  color: ${({ active }) => (active ? "#1F1F23" : "#757575")};
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: ${({ active }) => (active ? "700" : "500")};
  line-height: 18px;
  border-bottom: 1px solid
    ${({ active }) => (active ? "#1F1F23" : "rgba(30, 30, 30, 0.08)")};
  width: max-content;
  text-wrap: nowrap;
  padding: 0 16px;
  &:hover {
    border-bottom: 1px solid #1f1f23;
    color: #1f1f23;
  }
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 22px;

  @media (max-width: 850px) {
    font-size: 16px;
    padding: 0 12px;
    padding-bottom: 16px;
  }

  @media (max-width: 400px) {
    font-size: 14px;
    padding: 0 6px;
    padding-bottom: 10px;
  }
`

const TabInfo = styled(Tab)`
  width: 100%;
  gap: 24px;
  justify-content: flex-end;
  cursor: default;
  &:hover {
    border-bottom: 1px solid
      ${({ active }) => (active ? "#1F1F23" : "rgba(30, 30, 30, 0.08)")};
    color: inherit;
    font-weight: inherit;
  }
`

const Pricing = styled.div`
  color: ${props => props.theme.secondary600};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;

  @media (max-width: 850px) {
    display: none;
  }
`

const ButtonWrapper = styled.span`
  max-width: 152px;
  div {
    max-height: 46px;
    font-size: 16px;
    padding: 16px 28px;
  }
  @media (max-width: 850px) {
    display: none;
  }
`

const Header = ({ price, days, bookingURL }) => {
  return (
    <Container>
      <Tabs>
        <Tab active>Your itinerary</Tab>
        <Tab
          onClick={() => {
            const datesAndPrices = document.getElementById("dates-and-prices")
            if (datesAndPrices) {
              const yOffset = -100
              const y =
                datesAndPrices.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset
              window.scrollTo({ top: y, behavior: "smooth" })
            }
          }}
        >
          Dates & prices
        </Tab>
        <Tab
          onClick={() => {
            const reviewTitle = document.getElementById("reviews")
            if (reviewTitle) {
              const yOffset = -100
              const y =
                reviewTitle.getBoundingClientRect().top +
                window.pageYOffset +
                yOffset
              window.scrollTo({ top: y, behavior: "smooth" })
            }
          }}
        >
          Reviews
        </Tab>
        <TabInfo>
          <Pricing>
            {days} from{" "}
            {
              <Currency
                className="sticky-cta-price"
                amount={price?.amount}
                code={price?.currency?.code}
                showAbbr="after"
                applyRounding={!price?.discount ? "auto" : false}
                discounted={!!price?.discount}
              />
            }
          </Pricing>
          <ButtonWrapper>
            <Button to={bookingURL} text="Easy quote" type="black" />
          </ButtonWrapper>
        </TabInfo>
      </Tabs>
    </Container>
  )
}

Header.propTypes = {
  price: PropTypes.object,
  bookingURL: PropTypes.string,
}
export default Header
